// extracted by mini-css-extract-plugin
export var button = "styles-module--button--c1b3e";
export var desktop = "1340px";
export var display = "styles-module--display--127de";
export var fadeGrow = "styles-module--fade-grow--7466b";
export var fadeIn = "styles-module--fade-in--ef13c";
export var giant = "2200px";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var light = "styles-module--light--5fefa";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var spin = "styles-module--spin--ae0cf";
export var star = "styles-module--star--057d7";
export var tablet = "769px";
export var text = "styles-module--text--27855";